const bounds4228 = [

  [37.867756, -122.265893],
  [37.869241, -122.254555],
  [37.865597, -122.253925],
  [37.864157, -122.265218],

];

const bounds4227 = [

  [37.869241, -122.254555],
  [37.865597, -122.253925],
  [37.866181, -122.244746],
  [37.869601, -122.245016],
  [37.870276, -122.246681],

];

const bounds423602 = [

  [37.865597, -122.253925],
  [37.864157, -122.265218],
  [37.860467, -122.264453],
  [37.861772, -122.253475],

];

const bounds4237 = [

  [37.865597, -122.253925],
  [37.866181, -122.244746],
  [37.865552, -122.244566],
  [37.858935, -122.244499],
  [37.857375, -122.242257],
  [37.857034, -122.252977],
  [37.861772, -122.253475],

];

const bounds423601 = [

  [37.860467, -122.264453],
  [37.861772, -122.253475],
  [37.857034, -122.252977],
  [37.855724, -122.263478],

];

const bounds422901 = [
  [37.863557, -122.269671],
  [37.867103, -122.270253],
  [37.867756, -122.265893],
  [37.864157, -122.265218],

];

const bounds422902 = [

  [37.867103, -122.270253],
  [37.867756, -122.265893],
  [37.868771, -122.266203],
  [37.869591, -122.265793],
  [37.872316, -122.266086],
  [37.871407, -122.272971],
  [37.863292, -122.272063],
  [37.863557, -122.269671],

];

const bounds4224 = [

  [37.871407, -122.272971],
  [37.872316, -122.266086],
  [37.873945, -122.266335],
  [37.874231, -122.265317],
  [37.875567, -122.265444],
  [37.876299, -122.265348],
  [37.876808, -122.265571],
  [37.878717, -122.265698],
  [37.877635, -122.273684],

];

const bounds4225 = [
  [37.874231, -122.265317],
  [37.875567, -122.265444],
  [37.876299, -122.265348],
  [37.876808, -122.265571],
  [37.878717, -122.265698],
  [37.879703, -122.257522],
  [37.880403, -122.258031],
  [37.880435, -122.257077],
  [37.879957, -122.256441],
  [37.880148, -122.255041],
  [37.878526, -122.254913],
  [37.878395, -122.255286],
  [37.875562, -122.254664],
  [37.875527, -122.255390],
  [37.875044, -122.259917],
];

const data = {

  info: [
    {
      tract: '4228',
      general: 'Hi',
      coordinates: bounds4228,
      color: '#FFCCCC',
      rent: '1,759',
    },
    {
      tract: '4227',
      general: 'Hi',
      coordinates: bounds4227,
      color: '#FFD4D4',
      rent: '1,737',
    },
    {
      tract: '4236.02',
      general: 'Hi',
      coordinates: bounds423602,
      color: '#FF3232',
      rent: '2,185',
    },
    {
      tract: '4237',
      general: 'Hi',
      coordinates: bounds4237,
      color: '#FFEAEA',
      rent: '1,673',
    },
    {
      tract: '4236.01',
      general: 'Hi',
      coordinates: bounds423601,
      color: '#FFB0B0',
      rent: '1,838',
    },
    {
      tract: '4229.01',
      general: 'Hi',
      coordinates: bounds422901,
      color: '#FF7878',
      rent: '1,992',
    },
    {
      tract: '4229.02',
      general: 'Hi',
      coordinates: bounds422902,
      color: '#FFB0B0',
      rent: '1,836',
    },
    {
      tract: '4224',
      general: 'Hi',
      coordinates: bounds4224,
      color: '#FFA6A6',
      rent: '1,864',
    },
    {
      tract: '4225',
      general: 'Hi',
      coordinates: bounds4225,
      color: '#FFFAFA',
      rent: '1,630',
    },

  ],

  minLat: 37.8503526,
  maxLat: 37.899434,
  minLong: -122.3256618,
  maxLong: -122.2319033,

};

export default data;
